import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type APITokenTeaser = Pick<Types.APIToken, 'id' | 'name'>;

export const APITokenTeaser = gql`
  fragment APITokenTeaser on APIToken {
    id
    name
  }
`;
